<template>
	<div class="position-relative">
		<div class="order-bump-section">
			<div class="mb-3 text-sm ">Customize this product's currency to better reflect its target customers.</div>
		</div>
		<div class="d-flex flex-column">
			<div class="d-flex justify-content-start align-items-center ">
				<label class="text-bold mr-2 mb-0">Override default currency</label>
				<AppToggle v-model="value.enabled" :disabled="!isPaid" />
			</div>
		</div>
		<AppAccordion>
			<AppAccordionItem class="mb-0 overflow-visible shadow-none mt-3" :showHeader="false" :isWrapper="true" :name="accordionId">
				<div class="px-3">
					<div class="currency-dropdown-wrapper col-md-6 col-xl-4 pb-4">
						<AppDropdown
							v-model="value.currency"
							class="form-control"
							:options="currencyList"
							reduce="value"
							label="name"
							:clearable="false"
							:searchable="false"
						/>
					</div>
				</div>
			</AppAccordionItem>
		</AppAccordion>
	</div>
</template>
<script>
	import { mapGetters, mapActions } from 'vuex'

	export default {
		name: 'CurrencyOverrideForm',
		props: {
			isPaid: {
				type: Boolean,
				isPaid: true,
			},
			value: {
				type: Object,
				default: () => {},
			},
			validation: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return { accordionId: 'currency-override-form' }
		},
		mounted() {
			this.checkEnabled()
			if (Object.keys(this.getStoreSupportedCurrencies).length === 1) {
				this.fetchStoreSupportedCurrencies()
			}
		},
		computed: {
			...mapGetters('Auth', ['user']),
			...mapGetters('Stores', ['getStoreSupportedCurrencies']),
			currencyList() {
				return Object.entries(this.getStoreSupportedCurrencies).map(([currencyCode, currency]) => ({
					name:
						currencyCode === currency.symbol
							? `${currency.name} (${currencyCode})`
							: `${currency.name} (${currencyCode}, ${currency.symbol})`,
					value: currencyCode,
				}))
			},
		},
		methods: {
			...mapActions('Stores', ['fetchStoreSupportedCurrencies']),
			checkEnabled() {
				$(`#collapse${this.accordionId}`).collapse(this.value.enabled ? 'show' : 'hide')
			},
		},
		watch: {
			'value.enabled': {
				handler(newVal, oldVal) {
					if (oldVal === false) {
						this.$emit('input', { ...this.value, currency: this.user?.data?.currency ?? 'usd' })
					}
					this.checkEnabled()
				},
			},
		},
	}
</script>
